import { StandardEvents } from '@shopify/events';

let pending = 0;
let latest = 0;
function render(count) {
  document.querySelectorAll('.gg-cart-link').forEach(link => {
    const badge = link.querySelector('[data-gg-cart-count]');
    if (badge && Number.isFinite(count)) {
      badge.textContent = String(count);
      badge.hidden = count === 0;
      link.setAttribute('aria-label', `${link.dataset.cartLabel}: ${count}`);
    }
    const indicator = link.querySelector('.gg-cart-pending');
    if (indicator) indicator.hidden = pending === 0;
    link.setAttribute('aria-busy', String(pending > 0));
    if (pending) link.setAttribute('aria-label', link.dataset.updatingLabel);
  });
}
document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  if (!event.promise) return;
  pending += 1;
  const sequence = ++latest;
  render();
  event.promise.then(({ cart }) => {
    if (sequence === latest && cart) render(cart.totalQuantity);
  }).catch(() => {}).finally(() => {
    pending = Math.max(0, pending - 1);
    render();
    if (!pending) {
      document.querySelectorAll('.gg-cart-link').forEach(link => {
        link.setAttribute('aria-label', `${link.dataset.cartLabel}: ${link.querySelector('[data-gg-cart-count]')?.textContent || 0}`);
      });
    }
  });
});
document.addEventListener('click', event => {
  const link = event.target.closest?.('.gg-cart-link');
  const drawer = document.getElementById('cart-drawer');
  if (!link || !drawer?.open || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  drawer.open();
});
window.addEventListener('pageshow', async event => {
  if (!event.persisted) return;
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`);
    if (response.ok) render((await response.json()).item_count);
  } catch {}
});
